/**
 * @file paddlex 下载 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */

import {useState, useEffect} from 'react';
import {fetchGetReleaseNote} from '../../../../api/pages/paddlexApi';

import {IBanner} from './types.d';

const useReleaseNoteHooks = () => {
    const [banner, setBanner] = useState<IBanner>({
        title: '',
        subtitle: '',
        btns: []
    });
    const [releaseNote, setReleaseNote] = useState<string>('');

    useEffect(() => {
        (async () => {
            let res;
            try {
                res = await fetchGetReleaseNote();
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const pageData = res.body?.result?.pageData ?? {};
                const b = pageData.banner || {};
                setBanner({
                    title: b.title,
                    subtitle: b.subtitle,
                    btns: []
                });
                setReleaseNote(pageData.releaseNote || '');
            }
        })();
    }, []);

    return {
        banner,
        releaseNote
    };
};

export default useReleaseNoteHooks;
